export const orientationOptions = { left: 'left', right: 'right', up: 'up', down: 'down' };
